// constants

// action_component_subject
const SET_TOTO_THANK_YOU = "SET_TOTO_THANK_YOU";
const RESET_TOTO_THANK_YOU = "RESET_TOTO_THANK_YOU";

// reducers

const initialState = {};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_TOTO_THANK_YOU:
			return { ...action.payload };

		case RESET_TOTO_THANK_YOU:
			return {};

		default:
			return state;
	}
};

export default Reducer;

// actions

// const resolveAfter2Seconds = () => {
// 	return new Promise((resolve) => {
// 		setTimeout(() => {
// 			resolve("resolved");
// 		}, 2000);
// 	});
// };

// // action_component_subject
// export const decrementTestCounter = () => async (dispatch) => {
// 	const result = await resolveAfter2Seconds();
// 	console.log(result);
// 	dispatch({
// 		type: INCREMENT_TEST_COUNTER,
// 	});
// };

// action_component_subject, prefix set(not update),empty(not remove),hide,show
export const setTotoThankYou = (payload = {}) => {
	return {
		type: SET_TOTO_THANK_YOU,
		payload: payload,
	};
};

export const resetTotoThankYou = () => {
	return {
		type: RESET_TOTO_THANK_YOU,
	};
};
